import React from "react";
import * as S from "./styles";

const lastThreeDigits = (text) => text.substring(text.length, text.length - 3);

const File = ({ body, url, attachment_content_type, from }) => {
  const fileExtension = attachment_content_type
    ? lastThreeDigits(attachment_content_type)
    : "";

  const [_, message] = body.split("caption=");
  return (
    <S.Container from={from}>
      <S.Anchor
        className="file"
        href={url}
        target="_blank"
        rel="noopener noreferrer"
      >
        <S.Icon fileExtension={fileExtension} from={from} />

        <S.NameArchive className="text">{body}</S.NameArchive>

        <S.ContentIcon className="circle-container">
          <S.SpanIcon className="circle">
            <S.IconType className="icon" />
          </S.SpanIcon>
        </S.ContentIcon>
      </S.Anchor>
    </S.Container>
  );
};

export default File;
